import type { Flujo } from "./tipos"

/**
 * El contenido de la guía de uso (28/10). Cada botón, campo y pestaña se verificó contra el
 * código el mismo día: si una pantalla cambia un texto, aquí hay que cambiarlo también —
 * la guía que dice «pulsa Guardar» cuando el botón dice «Crear» es peor que no tener guía.
 *
 * Los valores de los campos son EJEMPLOS, para que se vea qué va en cada uno.
 */
export const FLUJOS: Flujo[] = [
  // --- Trabajo -----------------------------------------------------------------
  {
    id: "tarea-nueva",
    titulo: "Crear una tarea y asignarla",
    departamento: "Trabajo",
    cuando: "Cuando algo tiene que hacerlo alguien, con un plazo.",
    permiso: "tarea:crear",
    ruta: "/tareas",
    pasos: [
      {
        titulo: "Abre Tareas",
        texto: "Entra al módulo de tareas desde el menú.",
        elementos: [
          { tipo: "ruta", pasos: ["Trabajo", "Tareas"] },
          {
            tipo: "pestanas",
            opciones: ["Resumen", "Tablero", "Lista", "Carga"],
            activa: "Tablero",
          },
          { tipo: "boton", texto: "Nueva tarea", primario: true },
        ],
      },
      {
        titulo: "Llena lo obligatorio",
        texto:
          "Título, a quién se le asigna y para cuándo vence. Lo demás ayuda, pero sin responsable ni plazo nadie la persigue.",
        elementos: [
          {
            tipo: "campo",
            etiqueta: "Título *",
            valor: "Pedir el permiso sanitario del EXP 2026150",
            ancho: "largo",
          },
          { tipo: "lista", etiqueta: "Tipo", valor: "Operativa" },
          { tipo: "lista", etiqueta: "Prioridad", valor: "ALTA" },
          { tipo: "lista", etiqueta: "Asignar a *", valor: "Ailema Reyes" },
          { tipo: "campo", etiqueta: "Vence el *", valor: "30/10/2026", ancho: "corto" },
        ],
      },
      {
        titulo: "Adjunta si hace falta y crea",
        texto: "Puedes pegar capturas en cualquier parte del formulario.",
        elementos: [{ tipo: "boton", texto: "Crear tarea", primario: true }],
      },
    ],
    resultado:
      "Sale el aviso «Tarea creada» y la tarea nace pendiente en el tablero de la persona.",
    ojo: "Para moverla de estado se arrastra la tarjeta o se usa «Mover a»; eso pide el permiso tarea:actualizar.",
  },
  {
    id: "mis-solicitudes",
    titulo: "Pedir una constancia de trabajo o un permiso",
    departamento: "Trabajo",
    cuando: "Cuando necesitas una constancia, un permiso o tus vacaciones.",
    permiso: "documento_th:solicitar",
    ruta: "/mis-documentos",
    pasos: [
      {
        titulo: "Abre tus solicitudes",
        texto: "Va con los datos de tu ficha; sólo completas lo que falta.",
        elementos: [
          { tipo: "ruta", pasos: ["Trabajo", "Mis solicitudes"] },
          { tipo: "boton", texto: "Nueva solicitud", primario: true },
        ],
      },
      {
        titulo: "Elige el documento",
        texto: "Constancia de trabajo, Solicitud de permiso o Solicitud de vacaciones.",
        elementos: [{ tipo: "lista", etiqueta: "Documento", valor: "Solicitud de permiso" }],
      },
      {
        titulo: "Completa los datos del permiso",
        texto: "Si es por unas horas, escribe el horario; si son días completos, déjalo vacío.",
        elementos: [
          { tipo: "lista", etiqueta: "Tipo de permiso", valor: "Cita o reposo médico" },
          { tipo: "campo", etiqueta: "Desde el día", valor: "29/10/2026", ancho: "corto" },
          { tipo: "campo", etiqueta: "Hasta el día", valor: "29/10/2026", ancho: "corto" },
          {
            tipo: "campo",
            etiqueta: "Horario, si es por horas",
            valor: "de 8:00 a.m. a 11:00 a.m.",
          },
          { tipo: "campo", etiqueta: "Motivo", valor: "Control médico", ancho: "largo" },
        ],
      },
      {
        titulo: "Revisa y envía",
        texto: "Primero mira cómo queda el documento y luego envíalo.",
        elementos: [
          { tipo: "boton", texto: "Ver cómo queda" },
          { tipo: "boton", texto: "Enviar a Talento Humano", primario: true },
        ],
      },
    ],
    resultado:
      "Sale «Solicitud enviada» y queda «Pendiente» hasta que Talento Humano la apruebe o la rechace. Si la rechaza, verás el motivo.",
    ojo: "Si a tu ficha le faltan datos, el documento los enseña entre llaves: pide que completen tu ficha.",
  },
  {
    id: "mi-autoevaluacion",
    titulo: "Hacer mi autoevaluación del desempeño",
    departamento: "Trabajo",
    cuando: "Cuando la Dirección abre el período de evaluación (trimestral).",
    ruta: "/mis-evaluaciones",
    pasos: [
      {
        titulo: "Abre tu evaluación",
        texto: "La que dice «Te toca» es la que espera tu autoevaluación.",
        elementos: [{ tipo: "ruta", pasos: ["Trabajo", "Mis evaluaciones"] }],
      },
      {
        titulo: "Califica cada criterio",
        texto:
          "Escala de 1 a 5; si algo no se presentó en el período, marca N/O y no cuenta para el promedio.",
        elementos: [
          {
            tipo: "lista",
            etiqueta: "A1. Recepción y revisión de la documentación",
            valor: "4 · Muy bueno",
          },
          { tipo: "lista", etiqueta: "A10. Funciones adicionales", valor: "N/O · No observado" },
        ],
      },
      {
        titulo: "Responde las preguntas",
        texto: "Tus fortalezas, lo que debes mejorar, los obstáculos que encontraste y tus metas.",
        elementos: [
          {
            tipo: "campo",
            etiqueta: "¿Qué obstáculos encontraste?",
            valor: "Me faltaba acceso al estatus de ETA",
            ancho: "largo",
          },
        ],
      },
      {
        titulo: "Guarda o entrega",
        texto: "Puedes guardar un borrador y volver. Al entregar ya no se cambia.",
        elementos: [
          { tipo: "boton", texto: "Guardar borrador" },
          { tipo: "boton", texto: "Entregar a la Dirección", primario: true },
        ],
      },
    ],
    resultado:
      "Tu autoevaluación queda entregada. Después de la sesión 1 a 1 y del cierre, verás tu nota final, tu PDI y podrás dejar tus observaciones.",
  },

  // --- Administración ------------------------------------------------------------
  {
    id: "orden-pago",
    titulo: "Redactar una orden de pago y enviarla a aprobación",
    departamento: "Administración",
    cuando: "Cada vez que hay que pagarle algo a un proveedor.",
    antes: ["El proveedor creado en Proveedores administrativos", "La factura a mano"],
    permiso: "orden_pago:crear",
    ruta: "/administracion/ordenes-pago",
    pasos: [
      {
        titulo: "Abre las órdenes",
        texto: "Puedes redactarla a mano o dejar que la IA lea la factura.",
        elementos: [
          { tipo: "ruta", pasos: ["Administración", "Administración", "Órdenes de pago"] },
          { tipo: "boton", texto: "Nueva orden", primario: true },
          { tipo: "boton", texto: "Leer factura con IA" },
        ],
      },
      {
        titulo: "A mano: llena la orden",
        texto:
          "Proveedor, lo que se paga, la moneda, la categoría y para cuándo se necesita. Al elegir el proveedor salen sus servicios con su precio: pulsa uno para añadirlo como línea.",
        elementos: [
          { tipo: "lista", etiqueta: "Proveedor", valor: "CANTV" },
          { tipo: "boton", texto: "Añadir Internet de oficina" },
          {
            tipo: "campo",
            etiqueta: "Descripción",
            valor: "Internet de oficina, noviembre",
            ancho: "largo",
          },
          { tipo: "campo", etiqueta: "Valor", valor: "45,00", ancho: "corto" },
          { tipo: "lista", etiqueta: "Moneda de cobro", valor: "USD" },
          { tipo: "lista", etiqueta: "Categoría", valor: "Internet y telefonía" },
          { tipo: "campo", etiqueta: "Fecha requerida", valor: "05/11/2026", ancho: "corto" },
          { tipo: "boton", texto: "Crear", primario: true },
        ],
      },
      {
        titulo: "El mismo gasto en varios expedientes: una orden por cada uno, de una vez",
        texto:
          "Marca «Vinculada a un expediente» y escribe los números separados por coma o uno por línea. Sale una orden igual por cada expediente, todas en borrador; si alguno lleva otro monto, ajústalo en su orden antes de enviarla.",
        elementos: [
          {
            tipo: "campo",
            etiqueta: "N.º de expediente",
            valor: "2026119, 2026120, 2026121",
            ancho: "largo",
          },
          { tipo: "lista", etiqueta: "Proveedor", valor: "Gobernación del Estado Carabobo" },
          { tipo: "boton", texto: "Añadir Timbres Fiscales" },
          { tipo: "boton", texto: "Crear 3 órdenes", primario: true },
          {
            tipo: "nota",
            texto: "Un expediente repetido no deja crear: serían dos órdenes por el mismo gasto.",
          },
        ],
      },
      {
        titulo: "Con IA: sube la factura",
        texto:
          "Elige si es factura o solicitud de fondos, adjunta la foto o el PDF y deja que la lea. La orden sale en borrador para que la revises.",
        elementos: [
          { tipo: "boton", texto: "Adjuntar la factura (foto, captura o PDF)" },
          { tipo: "boton", texto: "Leer con IA", primario: true },
          {
            tipo: "nota",
            texto: "La factura se envía a Google (Gemini) para leerla.",
            tono: "aviso",
          },
        ],
      },
      {
        titulo: "Adjunta la factura y envía",
        texto: "En la ficha de la orden adjunta la factura y envíala a aprobación.",
        elementos: [
          { tipo: "boton", texto: "Adjuntar factura" },
          { tipo: "boton", texto: "Enviar a aprobación", primario: true },
        ],
      },
    ],
    resultado: "La orden pasa a «En aprobación» y le llega el aviso a quien aprueba.",
    ojo: "No se envía sin líneas, con monto cero o sin categoría.",
  },
  {
    id: "orden-aprobar",
    titulo: "Aprobar o rechazar una orden de pago",
    departamento: "Administración",
    cuando:
      "Cuando una orden está «En aprobación». Aprueban la Dirección Ejecutiva, la Gerencia Administrativa y la Coordinación Estratégica.",
    permiso: "orden_pago:aprobar",
    ruta: "/administracion/ordenes-pago",
    pasos: [
      {
        titulo: "Abre la orden",
        texto: "Revisa proveedor, monto, categoría y la factura adjunta.",
        elementos: [
          { tipo: "ruta", pasos: ["Administración", "Administración", "Órdenes de pago"] },
        ],
      },
      {
        titulo: "Aprueba",
        texto: "Si todo está bien, apruébala.",
        elementos: [{ tipo: "boton", texto: "Aprobar", primario: true }],
      },
      {
        titulo: "O recházala con su motivo",
        texto:
          "El motivo es obligatorio (mínimo 10 caracteres) y vuelve a borrador para corregirla.",
        elementos: [
          { tipo: "boton", texto: "Rechazar" },
          {
            tipo: "campo",
            etiqueta: "Motivo del rechazo",
            valor: "Falta la factura fiscal",
            ancho: "largo",
          },
          { tipo: "boton", texto: "Confirmar", primario: true },
        ],
      },
    ],
    resultado: "Aprobada, queda lista en Tesorería → Pagos por ejecutar.",
    ojo: "Quien redacta una orden no puede aprobarla, salvo quien tenga el permiso de autoaprobar: entonces el botón dice «Autoaprobar» y queda marcado.",
  },
  {
    id: "programado",
    titulo: "Programar un gasto que se repite",
    departamento: "Administración",
    cuando: "Para alquileres, servicios y todo lo que se paga cada semana, quincena o mes.",
    permiso: "gasto_programado:administrar",
    ruta: "/administracion/programados",
    pasos: [
      {
        titulo: "Abre Programados",
        texto: "",
        elementos: [
          { tipo: "ruta", pasos: ["Administración", "Administración", "Programados"] },
          { tipo: "boton", texto: "Programar un gasto", primario: true },
        ],
      },
      {
        titulo: "Dile qué, cuánto y cada cuánto",
        texto: "Según la frecuencia aparecen el día de la semana o el día del mes.",
        elementos: [
          { tipo: "lista", etiqueta: "Gasto del catálogo", valor: "Alquiler de oficina" },
          { tipo: "lista", etiqueta: "Frecuencia", valor: "Mensual" },
          { tipo: "campo", etiqueta: "Día de pago", valor: "5", ancho: "corto" },
          { tipo: "campo", etiqueta: "Monto", valor: "400,00", ancho: "corto" },
          { tipo: "campo", etiqueta: "Vigente desde", valor: "01/11/2026", ancho: "corto" },
          { tipo: "boton", texto: "Guardar", primario: true },
        ],
      },
    ],
    resultado:
      "Sale «Programación guardada». Cuando toca, el sistema redacta la orden en borrador.",
    ojo: "Un borrador no consume presupuesto ni se paga solo: hay que enviarlo a aprobación.",
  },
  {
    id: "partida",
    titulo: "Crear una partida de presupuesto",
    departamento: "Administración",
    cuando: "Para ponerle tope mensual a una categoría y recibir aviso cuando se acerque.",
    permiso: "gasto:administrar",
    ruta: "/administracion/presupuesto",
    pasos: [
      {
        titulo: "Abre Presupuesto",
        texto: "",
        elementos: [
          { tipo: "ruta", pasos: ["Administración", "Administración", "Presupuesto"] },
          { tipo: "boton", texto: "Nueva partida", primario: true },
        ],
      },
      {
        titulo: "Pon el tope",
        texto: "",
        elementos: [
          { tipo: "lista", etiqueta: "Categoría", valor: "Suministros de oficina" },
          { tipo: "campo", etiqueta: "Tope del mes (USD)", valor: "400", ancho: "corto" },
          { tipo: "campo", etiqueta: "Avisar a partir de (%)", valor: "80", ancho: "corto" },
          { tipo: "boton", texto: "Crear partida", primario: true },
        ],
      },
    ],
    resultado: "La partida aparece con lo consumido del período.",
    ojo: "Una sola partida viva por categoría. El presupuesto avisa (campanita y Telegram), no bloquea pagos.",
  },
  {
    id: "reportes",
    titulo: "Leer los reportes de administración",
    departamento: "Administración",
    cuando: "Para ver cómo va el gasto contra el presupuesto, el flujo de caja y en qué se gasta.",
    permiso: "informe_gasto:ver",
    ruta: "/administracion/reportes",
    pasos: [
      {
        titulo: "Abre Reportes y elige el período",
        texto:
          "Por omisión es la semana; puedes elegir 15, 30 o 60 días o el mes, y moverte con las flechas.",
        elementos: [
          { tipo: "ruta", pasos: ["Administración", "Administración", "Reportes"] },
          {
            tipo: "pestanas",
            opciones: ["Semana", "15 días", "30 días", "60 días", "Mes"],
            activa: "Mes",
          },
        ],
      },
      {
        titulo: "Lee los tres bloques",
        texto:
          "Cuentas y resultados: presupuesto, gasto real, por cancelar y disponible por categoría y partida. Flujo de caja: lo que entró y salió de los bancos. Composición: fijo contra variable y qué se compró.",
        elementos: [
          {
            tipo: "nota",
            texto: "Pulsa un mes del gráfico de flujo y todos los reportes pasan a ese mes.",
          },
        ],
      },
    ],
    resultado:
      "Ves en una sola pantalla con cuánto se contaba, cuánto se gastó y cuánto salió del banco.",
  },

  {
    id: "datos-pago-proveedor",
    titulo: "Cargar los datos de pago de un proveedor",
    departamento: "Administración",
    cuando: "Cuando un proveedor da su cuenta, su pago móvil, su Zelle o su Binance.",
    permiso: "proveedor:administrar",
    ruta: "/proveedores/administrativos",
    pasos: [
      {
        titulo: "Abre su ficha",
        texto: "Pulsa el proveedor en la lista. Los operativos están en Operaciones Aduaneras.",
        elementos: [
          { tipo: "ruta", pasos: ["Administración", "Proveedores administrativos"] },
          { tipo: "boton", texto: "Agregar" },
        ],
      },
      {
        titulo: "Elige qué es y llénalo",
        texto:
          "Cada clase pide lo suyo. En una cuenta venezolana el banco sale solo de los cuatro primeros dígitos; titular y cédula vacíos son los del proveedor.",
        elementos: [
          { tipo: "lista", etiqueta: "Qué es", valor: "Pago móvil" },
          { tipo: "lista", etiqueta: "Banco", valor: "0134 · Banesco" },
          { tipo: "campo", etiqueta: "Teléfono", valor: "0412-1234567", ancho: "corto" },
          { tipo: "boton", texto: "Guardar", primario: true },
        ],
      },
    ],
    resultado:
      "Queda en «Datos de pago» de su ficha, y tesorería lo ve en la orden aprobada y al elegir el método en el pago.",
    ojo: "Los datos de un mensaje de WhatsApp no se cargan aquí solos: pueden ser de un tercero.",
  },

  {
    id: "servicios-proveedor",
    titulo: "Cargar los servicios de un tipo de proveedor y el precio de cada uno",
    departamento: "Administración",
    cuando:
      "Cuando varios proveedores prestan lo mismo —el almacenaje de las almacenadoras— o cambia un precio.",
    permiso: "gasto:administrar",
    ruta: "/tipos-proveedor",
    pasos: [
      {
        titulo: "Crea el servicio UNA vez, en su tipo",
        texto:
          "Abre el tipo de proveedor y agrega el servicio con un precio de referencia. Lo verán todas las almacenadoras.",
        elementos: [
          { tipo: "ruta", pasos: ["Administración", "Tipos de proveedor"] },
          { tipo: "boton", texto: "Agregar servicio" },
          { tipo: "campo", etiqueta: "Nombre", valor: "Almacenaje", ancho: "largo" },
          { tipo: "campo", etiqueta: "Monto de referencia", valor: "100,00", ancho: "corto" },
          { tipo: "lista", etiqueta: "Divisa", valor: "USD" },
          { tipo: "boton", texto: "Guardar", primario: true },
        ],
      },
      {
        titulo: "En la ficha de cada proveedor, marca los que presta y su precio",
        texto:
          "Pulsa el proveedor y en «Servicios y precios» agrega el servicio de su tipo. Sin precio propio vale el de referencia. Un proveedor de varios tipos ve los de todos.",
        elementos: [
          { tipo: "ruta", pasos: ["Operaciones Aduaneras", "Proveedores operativos"] },
          { tipo: "boton", texto: "Agregar servicio" },
          { tipo: "lista", etiqueta: "Servicio", valor: "Almacenaje" },
          { tipo: "campo", etiqueta: "Su precio", valor: "150,00", ancho: "corto" },
          { tipo: "boton", texto: "Guardar", primario: true },
        ],
      },
    ],
    resultado:
      "Al redactarle una orden de pago a ese proveedor, sus servicios salen a la vista con su precio.",
    ojo: "Lo que sólo se le paga a un proveedor —el alquiler de la oficina— se agrega en su ficha como «uno que sólo le paga la agencia».",
  },

  // --- Finanzas --------------------------------------------------------------------
  {
    id: "ejecutar-pago",
    titulo: "Ejecutar el pago de una orden aprobada",
    departamento: "Finanzas",
    cuando: "Cuando una orden está aprobada y se va a pagar.",
    permiso: "tesoreria:ejecutar_pago",
    ruta: "/tesoreria/pagos",
    pasos: [
      {
        titulo: "Abre Pagos por ejecutar",
        texto: "Pulsa la fila de la orden para abrir su ficha.",
        elementos: [
          { tipo: "ruta", pasos: ["Finanzas", "Tesorería", "Pagos por ejecutar"] },
          { tipo: "boton", texto: "Ejecutar pago", primario: true },
        ],
      },
      {
        titulo: "Llena el pago",
        texto:
          "La cuenta que paga, lo que se debitó y la referencia. Si la cuenta tiene PIN, se escribe ahí mismo.",
        elementos: [
          { tipo: "lista", etiqueta: "Cuenta que paga", valor: "BBVA Provincial" },
          { tipo: "lista", etiqueta: "Método de pago", valor: "Pago movil" },
          {
            tipo: "nota",
            texto:
              "Al elegir el método salen los datos del proveedor para ese método —su cuenta, su pago móvil, su Zelle— con «Copiar» al lado de cada uno.",
          },
          { tipo: "campo", etiqueta: "Monto debitado", valor: "45,00", ancho: "corto" },
          { tipo: "campo", etiqueta: "Referencia bancaria", valor: "004512", ancho: "corto" },
          { tipo: "campo", etiqueta: "Fecha valor", valor: "28/10/2026", ancho: "corto" },
        ],
      },
      {
        titulo: "Adjunta el comprobante",
        texto: "La IA puede leerlo. Si de verdad no hay comprobante, márcalo y explica por qué.",
        elementos: [
          { tipo: "boton", texto: "Adjuntar comprobante" },
          { tipo: "boton", texto: "Ejecutar pago", primario: true },
        ],
      },
    ],
    resultado: "Sale «Pago registrado» y la orden pasa a Ejecutada.",
    ojo: "Para varias órdenes del mismo proveedor y moneda: márcalas y usa «Pagar juntas».",
  },
  {
    id: "ingreso",
    titulo: "Registrar un ingreso y aplicarlo a cuentas por cobrar",
    departamento: "Finanzas",
    cuando: "Cuando entra dinero a un banco.",
    permiso: "ingreso:registrar",
    ruta: "/tesoreria/ingresos",
    pasos: [
      {
        titulo: "Abre Ingresos",
        texto: "",
        elementos: [
          { tipo: "ruta", pasos: ["Finanzas", "Tesorería", "Ingresos"] },
          { tipo: "boton", texto: "Reportar ingreso", primario: true },
        ],
      },
      {
        titulo: "Llena el ingreso",
        texto: "Adjunta el comprobante (la IA lo puede leer), la cuenta, el monto y quién pagó.",
        elementos: [
          { tipo: "lista", etiqueta: "Cuenta donde entró", valor: "Binance" },
          { tipo: "campo", etiqueta: "Monto", valor: "1.000,00", ancho: "corto" },
          { tipo: "campo", etiqueta: "Referencia bancaria", valor: "TX-88213", ancho: "corto" },
          { tipo: "pestanas", opciones: ["Cliente", "Proveedor", "Empleado"], activa: "Cliente" },
        ],
      },
      {
        titulo: "Revisa a qué cuentas va",
        texto:
          "Si pagó un cliente, el sistema propone sus cuentas por cobrar de la misma moneda, de la más vieja a la más nueva. Lo que sobra queda como anticipo.",
        elementos: [{ tipo: "boton", texto: "Reportar ingreso", primario: true }],
      },
    ],
    resultado: "Sale «Ingreso reportado» y las cuentas por cobrar bajan su saldo.",
    ojo: "Sin pagador queda «Por determinar»: el dinero está en el banco, pero no cobra la cuenta de nadie.",
  },
  {
    id: "cxp-orden",
    titulo: "Pagar una cuenta por pagar del 2.0",
    departamento: "Finanzas",
    cuando: "Cuando una CxP del 2.0 se va a pagar con un banco del 3.0.",
    permiso: "orden_pago:crear",
    ruta: "/libro-cuentas/por-pagar",
    pasos: [
      {
        titulo: "Abre las cuentas por pagar",
        texto: "",
        elementos: [{ tipo: "ruta", pasos: ["Finanzas", "Libro de Cuentas", "Cuentas por pagar"] }],
      },
      {
        titulo: "Si está en borrador, carga el soporte",
        texto: "Sin nota de despacho o factura no se paga.",
        elementos: [{ tipo: "boton", texto: "Cargar soporte" }],
      },
      {
        titulo: "Genera su orden",
        texto: "Sale en borrador por el saldo; de ahí sigue el circuito de siempre.",
        elementos: [{ tipo: "boton", texto: "Generar orden de pago", primario: true }],
      },
    ],
    resultado: "Sale «Orden de pago redactada» y la fila enseña el código de la orden.",
    ojo: "Una CxP del 2.0 se paga con una orden, nunca con un abono suelto. Cargar soporte pide el permiso cxp:pagar.",
  },
  {
    id: "resumen-macro",
    titulo: "Leer el Resumen Macro y planificar los pagos del viernes",
    departamento: "Finanzas",
    cuando: "Para saber cuánto hay, cuánto se debe y qué alcanza a pagarse.",
    permiso: "resumen_macro:ver",
    ruta: "/resumen-macro",
    pasos: [
      {
        titulo: "Lee los tres pasos",
        texto:
          "Disponibilidad total, la reserva de 40 % que no se toca y los compromisos contra la cobertura. USD y USDT cuentan 1:1; arriba eliges a qué tasa se valoran los bolívares. Debajo, las tarjetas de entradas y compromisos abren su detalle justo bajo ellas.",
        elementos: [{ tipo: "ruta", pasos: ["Finanzas", "Resumen macro"] }],
      },
      {
        titulo: "Consulta un banco",
        texto:
          "En la pestaña Bancos, haz clic en una cuenta: se abre su ficha con el saldo y los últimos 100 movimientos. Es sólo consulta, no pide PIN y es sólo para gerencia; registrar o corregir se hace en Tesorería. Una CxC o una CxP también abre su detalle al hacer clic.",
        elementos: [
          {
            tipo: "pestanas",
            opciones: [
              "Bancos",
              "CxP operativas",
              "Administrativos por pagar",
              "Planificador del viernes",
            ],
            activa: "Bancos",
          },
        ],
      },
      {
        titulo: "Abre el Planificador del viernes",
        texto:
          "Propone qué pagar sin tocar la reserva. Marca o desmarca y redacta las órdenes de lo elegido.",
        elementos: [
          {
            tipo: "pestanas",
            opciones: [
              "Bancos",
              "CxP operativas",
              "Administrativos por pagar",
              "Planificador del viernes",
            ],
            activa: "Planificador del viernes",
          },
          { tipo: "boton", texto: "Redactar las órdenes de lo elegido", primario: true },
        ],
      },
    ],
    resultado: "Las órdenes salen en borrador; se aprueban y se pagan por Tesorería.",
  },

  // --- Talento Humano -----------------------------------------------------------------
  {
    id: "ficha",
    titulo: "Crear la ficha de un empleado",
    departamento: "Talento Humano",
    cuando: "Cuando entra alguien a la agencia.",
    permiso: "persona:administrar",
    ruta: "/talento-humano/personas",
    pasos: [
      {
        titulo: "Abre Personas",
        texto: "",
        elementos: [
          { tipo: "ruta", pasos: ["Talento Humano", "Talento humano", "Personas"] },
          { tipo: "boton", texto: "Nueva ficha", primario: true },
        ],
      },
      {
        titulo: "Lo mínimo",
        texto: "La IA puede llenar los datos con la cédula, el RIF y el currículo.",
        elementos: [
          { tipo: "lista", etiqueta: "Tipo de ficha", valor: "Empleado" },
          { tipo: "campo", etiqueta: "Nombres", valor: "María José" },
          { tipo: "campo", etiqueta: "Apellidos", valor: "Pérez" },
          { tipo: "campo", etiqueta: "Número", valor: "V-20123456", ancho: "corto" },
          { tipo: "lista", etiqueta: "Cargo", valor: "Asistente Administrativo" },
          { tipo: "boton", texto: "Crear ficha", primario: true },
        ],
      },
      {
        titulo: "Complétala",
        texto:
          "La ficha se abre para leer: pulsa «Editar ficha» y completa fecha de ingreso, teléfono corporativo y, si entra al sistema, su cuenta. Si su cargo está en varios departamentos, elige el suyo.",
        elementos: [
          { tipo: "boton", texto: "Editar ficha" },
          { tipo: "lista", etiqueta: "Departamento", valor: "Finanzas" },
          { tipo: "lista", etiqueta: "Cuenta enlazada", valor: "Sin cuenta — no entra al sistema" },
          { tipo: "boton", texto: "Guardar cambios", primario: true },
        ],
      },
    ],
    resultado:
      "La persona queda en Personas, en el organigrama de su cargo y lista para contrato y nómina.",
  },
  {
    id: "contrato-nomina",
    titulo: "Crear el contrato de nómina",
    departamento: "Talento Humano",
    cuando: "Para que la persona cobre por nómina.",
    permiso: "nomina:administrar",
    ruta: "/talento-humano/contratos",
    pasos: [
      {
        titulo: "Abre Contratos",
        texto: "",
        elementos: [
          { tipo: "ruta", pasos: ["Talento Humano", "Talento humano", "Contratos"] },
          { tipo: "boton", texto: "Nuevo contrato", primario: true },
        ],
      },
      {
        titulo: "Sueldo y frecuencia",
        texto: "El sueldo es el de CADA pago, no el del mes.",
        elementos: [
          { tipo: "lista", etiqueta: "Empleado", valor: "María José Pérez" },
          { tipo: "campo", etiqueta: "Sueldo por pago", valor: "150,00", ancho: "corto" },
          { tipo: "lista", etiqueta: "Moneda", valor: "USD" },
          { tipo: "lista", etiqueta: "Frecuencia", valor: "Quincenal" },
          { tipo: "boton", texto: "Crear contrato", primario: true },
        ],
      },
    ],
    resultado: "Entra en la próxima nómina que genere el sistema.",
  },
  {
    id: "documento-th",
    titulo: "Emitir un documento o resolver una solicitud",
    departamento: "Talento Humano",
    cuando: "Constancias, acuerdos, llamados de atención; o cuando un empleado pidió algo.",
    permiso: "documento_th:emitir",
    ruta: "/talento-humano/documentos",
    pasos: [
      {
        titulo: "Emitir",
        texto: "Elige la plantilla y el empleado; se llena con su ficha.",
        elementos: [
          { tipo: "ruta", pasos: ["Talento Humano", "Talento humano", "Documentos"] },
          { tipo: "boton", texto: "Generar documento", primario: true },
          { tipo: "lista", etiqueta: "Documento", valor: "Constancia de trabajo" },
          { tipo: "boton", texto: "Ver cómo queda" },
          { tipo: "boton", texto: "Emitir", primario: true },
        ],
      },
      {
        titulo: "Resolver una solicitud",
        texto:
          "Abre la solicitud pendiente y apruébala, o recházala con su motivo (el empleado lo verá).",
        elementos: [
          { tipo: "boton", texto: "Aprobar", primario: true },
          { tipo: "boton", texto: "Rechazar" },
        ],
      },
    ],
    resultado:
      "El documento queda emitido o resuelto, con su código, para imprimir o subir firmado.",
  },
  {
    id: "permisos",
    titulo: "Controlar los permisos del personal",
    departamento: "Talento Humano",
    cuando:
      "Para ver quién pidió permiso, qué falta por resolver y cuánto lleva cada uno en el año.",
    permiso: "documento_th:ver",
    ruta: "/talento-humano/permisos",
    pasos: [
      {
        titulo: "Abre Permisos",
        texto: "Arriba: lo que falta por resolver y los días hábiles aprobados del año.",
        elementos: [{ tipo: "ruta", pasos: ["Talento Humano", "Talento humano", "Permisos"] }],
      },
      {
        titulo: "Resuelve lo pendiente",
        texto: "Cada solicitud por resolver lleva a su documento, donde se aprueba o se rechaza.",
        elementos: [{ tipo: "boton", texto: "Resolver" }],
      },
    ],
    resultado: "Debajo, el acumulado por persona y por tipo de permiso.",
  },
  {
    id: "evaluacion",
    titulo: "Evaluar el desempeño de un trabajador",
    departamento: "Talento Humano",
    cuando:
      "Cada trimestre. Trabajador y Dirección califican por separado y lo acuerdan en una sesión 1 a 1.",
    permiso: "evaluacion:administrar",
    ruta: "/talento-humano/evaluaciones",
    pasos: [
      {
        titulo: "Abre la evaluación",
        texto: "Elige la persona y el período. El formulario sale de su cargo.",
        elementos: [
          { tipo: "ruta", pasos: ["Talento Humano", "Talento humano", "Evaluaciones"] },
          { tipo: "boton", texto: "Nueva evaluación", primario: true },
        ],
      },
      {
        titulo: "Califica como Dirección, antes de leer la autoevaluación",
        texto:
          "Indicadores del período, y cada criterio con los hechos observados. La autoevaluación queda tapada hasta que la pidas.",
        elementos: [
          { tipo: "lista", etiqueta: "B5. Manejo de la presión", valor: "3 · Cumple" },
          { tipo: "boton", texto: "Guardar", primario: true },
        ],
      },
      {
        titulo: "En la sesión 1 a 1, consolida",
        texto:
          "Revisa los bloques con brecha mayor que 1,0, fija la nota acordada, la valoración y el PDI.",
        elementos: [
          { tipo: "boton", texto: "Ver la autoevaluación" },
          { tipo: "boton", texto: "Consolidar (sesión hecha)", primario: true },
        ],
      },
      {
        titulo: "Cierra con el PDI firmado",
        texto: "Con al menos un compromiso del trabajador y la fecha de seguimiento.",
        elementos: [{ tipo: "boton", texto: "Cerrar con el PDI firmado", primario: true }],
      },
    ],
    resultado:
      "La nota final y su nivel quedan en la evaluación, y el trabajador ya la ve en «Mis evaluaciones».",
    ojo: "Regla de ética: si la Dirección pone 1 o 2 en un criterio del bloque E, la nota final no pasa de «Cumple».",
  },

  // --- Dirección Ejecutiva ---------------------------------------------------------------
  {
    id: "cargo",
    titulo: "Crear un cargo con sus funciones",
    departamento: "Dirección Ejecutiva",
    cuando: "Cuando aparece un puesto nuevo o cambian sus funciones.",
    permiso: "cargo:administrar",
    ruta: "/planificacion/cargos",
    pasos: [
      {
        titulo: "Abre Cargos",
        texto: "",
        elementos: [
          { tipo: "ruta", pasos: ["Dirección Ejecutiva", "Planificación estratégica", "Cargos"] },
          { tipo: "boton", texto: "Nuevo", primario: true },
          { tipo: "campo", etiqueta: "Nombre del puesto", valor: "Contador" },
          { tipo: "boton", texto: "Crear cargo", primario: true },
        ],
      },
      {
        titulo: "Llena su descriptivo",
        texto:
          "Departamento, nivel, a quién reporta, para qué existe y sus funciones en orden: así salen en el contrato. Si el mismo puesto está en otro departamento, márcalo como excepción.",
        elementos: [
          { tipo: "lista", etiqueta: "Departamento", valor: "Contabilidad" },
          { tipo: "lista", etiqueta: "Reporta a", valor: "Director Ejecutivo" },
          { tipo: "boton", texto: "Añadir función" },
          { tipo: "boton", texto: "Guardar cargo", primario: true },
        ],
      },
    ],
    resultado: "El cargo queda en el catálogo, para las fichas, los contratos y el organigrama.",
    ojo: "Un cargo no se borra: se retira del catálogo, y sólo si nadie lo tiene.",
  },
  {
    id: "organigrama",
    titulo: "Completar el organigrama",
    departamento: "Dirección Ejecutiva",
    cuando: "Cuando cambian los cargos o las personas.",
    permiso: "organigrama:editar",
    ruta: "/planificacion/organigrama",
    pasos: [
      {
        titulo: "Abre el organigrama",
        texto: "El vigente es «Estructura 2026 — sede propia».",
        elementos: [
          {
            tipo: "ruta",
            pasos: ["Dirección Ejecutiva", "Planificación estratégica", "Organigrama"],
          },
          { tipo: "boton", texto: "Editar" },
        ],
      },
      {
        titulo: "Completa desde los cargos o añade posiciones",
        texto: "«Completar desde cargos» enseña la propuesta antes de aplicarla y sólo añade.",
        elementos: [
          { tipo: "boton", texto: "Completar desde cargos" },
          { tipo: "boton", texto: "Añadir posición" },
          { tipo: "boton", texto: "Exportar PDF" },
        ],
      },
    ],
    resultado: "El organigrama queda al día y se puede imprimir.",
  },

  // --- Comercial / Logística / Imagen ----------------------------------------------------------
  {
    id: "cotizacion",
    titulo: "Hacer una cotización a un cliente",
    departamento: "Comercial",
    cuando: "Cuando un cliente pide precio de un servicio.",
    permiso: "cotizacion:crear",
    ruta: "/cotizaciones",
    pasos: [
      {
        titulo: "Abre Cotizaciones",
        texto: "Es un asistente de tres pasos: cliente, ítems y revisión.",
        elementos: [
          { tipo: "ruta", pasos: ["Comercial", "Cotizaciones"] },
          { tipo: "boton", texto: "Nueva", primario: true },
        ],
      },
      {
        titulo: "Cliente y aduana",
        texto: "La aduana es obligatoria.",
        elementos: [
          { tipo: "lista", etiqueta: "Cliente", valor: "Fábrica de Velas C.A." },
          { tipo: "lista", etiqueta: "Aduana", valor: "Puerto Cabello" },
          { tipo: "boton", texto: "Siguiente" },
        ],
      },
      {
        titulo: "Ítems y revisión",
        texto: "Concepto, cantidad y precio en USD; el total se calcula solo.",
        elementos: [
          { tipo: "boton", texto: "Añadir línea" },
          { tipo: "boton", texto: "Crear cotización", primario: true },
        ],
      },
    ],
    resultado: "Nace en borrador; desde su detalle se aprueba.",
  },
  {
    id: "fletes",
    titulo: "Recibir los recibos de flete de los intermediarios",
    departamento: "Logística de Carga",
    cuando: "Cuando un intermediario de transporte carga su recibo en su portal.",
    permiso: "transporte:recibir",
    ruta: "/fletes",
    pasos: [
      {
        titulo: "Abre Fletes y transporte",
        texto: "Los recibos los emiten los intermediarios; aquí se ven con sus soportes.",
        elementos: [
          { tipo: "ruta", pasos: ["Logística de Carga", "Fletes y transporte"] },
          {
            tipo: "pestanas",
            opciones: ["Recibos de flete", "Cargas asignadas", "Intermediarios"],
            activa: "Recibos de flete",
          },
        ],
      },
      {
        titulo: "Márcalo recibido",
        texto: "",
        elementos: [{ tipo: "boton", texto: "Marcar recibido en administración", primario: true }],
      },
    ],
    resultado: "El recibo queda recibido por administración.",
    ojo: "Las cargas se asignan en el 2.0; aquí sólo se consultan.",
  },
  {
    id: "rotulo",
    titulo: "Hacer el rótulo de una carpeta",
    departamento: "Imagen Corporativa",
    cuando: "Al abrir la carpeta física de un cliente o un expediente.",
    permiso: "rotulo:editar",
    ruta: "/rotulacion",
    pasos: [
      {
        titulo: "Elige la compañía y el formato",
        texto:
          "Setieca Agentes Aduanales o Setieca Trade Logistics Corp, y después pestaña, etiqueta de tapa, lomo, carátula o tejuelo de libro.",
        elementos: [
          { tipo: "ruta", pasos: ["Imagen Corporativa", "Rotulación"] },
          {
            tipo: "pestanas",
            opciones: [
              "Pestaña",
              "Etiqueta de tapa",
              "Lomo de carpeta",
              "Carátula",
              "Tejuelo de libro",
            ],
            activa: "Pestaña",
          },
        ],
      },
      {
        titulo: "Precarga los datos",
        texto:
          "Escribe el número de cliente o de expediente y pulsa Intro: trae razón social, RIF y siglas, sin pisar lo que ya escribiste.",
        elementos: [
          { tipo: "campo", etiqueta: "N.° de expediente", valor: "2026150", ancho: "corto" },
        ],
      },
      {
        titulo: "Guárdalo e imprímelo",
        texto: "",
        elementos: [
          {
            tipo: "campo",
            etiqueta: "Con qué nombre lo buscarás después",
            valor: "EXP 2026150 Fábrica de Velas",
          },
          { tipo: "boton", texto: "Guardar" },
          { tipo: "campo", etiqueta: "Copias", valor: "2", ancho: "corto" },
          { tipo: "boton", texto: "Imprimir", primario: true },
        ],
      },
    ],
    resultado: "El rótulo queda guardado para reimprimirlo cuando haga falta.",
  },

  // --- Sistema ---------------------------------------------------------------------------
  {
    id: "usuario",
    titulo: "Dar acceso al sistema a una persona",
    departamento: "Sistema",
    cuando: "Cuando alguien del equipo o un cliente necesita entrar.",
    permiso: "usuario:administrar",
    ruta: "/admin/usuarios",
    pasos: [
      {
        titulo: "Invita al usuario",
        texto: "No hay registro público: toda cuenta nace por invitación.",
        elementos: [
          { tipo: "ruta", pasos: ["Sistema", "Usuarios"] },
          { tipo: "boton", texto: "Invitar usuario", primario: true },
          { tipo: "campo", etiqueta: "Correo", valor: "mjperez@setiecadesk.com" },
          { tipo: "campo", etiqueta: "Nombre", valor: "María José Pérez" },
          { tipo: "lista", etiqueta: "Tipo", valor: "Interno (personal de SETIECA)" },
        ],
      },
      {
        titulo: "Dale sus roles",
        texto: "Los roles deciden qué ve y qué puede hacer.",
        elementos: [{ tipo: "boton", texto: "Crear usuario", primario: true }],
      },
    ],
    resultado:
      "La persona entra con su correo y la contraseña inicial. Enlázala con su ficha en Personas.",
  },
  {
    id: "telegram",
    titulo: "Recibir los avisos en un grupo de Telegram",
    departamento: "Sistema",
    cuando: "Para que un grupo o tema reciba avisos y reportes del sistema.",
    permiso: "usuario:administrar",
    ruta: "/perfil",
    pasos: [
      {
        titulo: "Crea el grupo",
        texto: "",
        elementos: [
          { tipo: "ruta", pasos: ["Mi cuenta", "Grupos de Telegram"] },
          { tipo: "campo", etiqueta: "Nombre", valor: "Finanzas" },
          { tipo: "boton", texto: "Crear grupo", primario: true },
        ],
      },
      {
        titulo: "Enlázalo",
        texto:
          "Genera el código y escríbelo en el grupo (o dentro del tema) como /vincular CÓDIGO. Caduca a los 15 minutos.",
        elementos: [{ tipo: "boton", texto: "Generar código para enlazar" }],
      },
      {
        titulo: "Marca qué recibe",
        texto: "Las casillas se guardan al marcarlas.",
        elementos: [
          {
            tipo: "nota",
            texto: "En un grupo con temas, todos los miembros ven todos los temas.",
            tono: "aviso",
          },
        ],
      },
    ],
    resultado:
      "El grupo empieza a recibir los avisos marcados, también los de lo que hace uno mismo.",
  },
  {
    id: "exportar",
    titulo: "Exportar una tabla o un reporte a Excel o PDF",
    departamento: "Trabajo",
    cuando: "Para enviar, imprimir o trabajar en Excel lo que tienes en pantalla.",
    ruta: "/tesoreria/movimientos",
    pasos: [
      {
        titulo: "Deja la pantalla como la quieres",
        texto:
          "Elige el período, los filtros y la búsqueda: se exporta exactamente lo que se ve, con las filas cargadas.",
        elementos: [
          { tipo: "ruta", pasos: ["Finanzas", "Tesorería", "Movimientos"] },
          { tipo: "campo", etiqueta: "Desde", valor: "01/10/2026", ancho: "corto" },
          { tipo: "campo", etiqueta: "Hasta", valor: "31/10/2026", ancho: "corto" },
        ],
      },
      {
        titulo: "Pulsa «Exportar» y elige el formato",
        texto:
          "Excel trae las cifras como números, listas para sumar y filtrar. PDF sale con el membrete de la agencia para enviarlo o imprimirlo.",
        elementos: [
          { tipo: "boton", texto: "Exportar" },
          {
            tipo: "nota",
            texto:
              "Una pantalla con varias tablas sale en varias hojas de Excel o en varios apartados del PDF.",
          },
        ],
      },
    ],
    resultado:
      "Se descarga el archivo con el logo, la razón social, el RIF, la dirección, qué se filtró, quién lo generó y cuándo.",
    ojo: "Si la lista se carga por tandas, pulsa «Ver más» antes de exportar para que salgan todas las filas.",
  },
]
